/* eslint-disable no-console */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserAgencies, switchUserAgency } from '../service';
import { AuthQueryFactory } from '../utils/query-factory';

function useAgencySwitcher({
    onSuccess = () => {},
    onFailure = () => {},
}: {
    onSuccess?: () => void;
    onFailure?: () => void;
} = {}) {
    const queryClient = useQueryClient();

    const getAgenciesQuery = useQuery({
        queryKey: AuthQueryFactory.userAgencies(),
        queryFn: () => getUserAgencies(),
    });

    const switchPortfolioMutation = useMutation({
        mutationFn: (agencyId: number) => switchUserAgency(agencyId),
        onSuccess: (_newAgencySession) => {
            queryClient.removeQueries({
                queryKey: [],
                predicate: (query) => query.queryKey[0] !== 'auth',
            });

            queryClient.removeQueries({
                queryKey: AuthQueryFactory.systemStates(),
            });

            queryClient.removeQueries({
                queryKey: AuthQueryFactory.userAgencies(),
            });

            queryClient.setQueryData(AuthQueryFactory.session(), _newAgencySession);

            onSuccess();
        },
        onError: (err) => {
            console.error('Failed to switch portfolio', err);
            onFailure();
        },
    });

    const switchUserPortfolio = (agencyId: number) => {
        switchPortfolioMutation.mutate(agencyId);
    };

    return {
        isLoading: getAgenciesQuery.isLoading
            || getAgenciesQuery.isError
            || getAgenciesQuery.data === undefined,
        userAgencies: getAgenciesQuery.data,
        isSwitchingPortfolio: switchPortfolioMutation.isPending,
        switchUserPortfolio,
    };
}

export { useAgencySwitcher };
